export const SelectBoxArrowUp = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.13438 15.6454L4.38522 15.8763C4.56439 16.0412 4.81523 16.0412 4.9944 15.8763L11.9821 9.4433L19.0056 15.8763C19.1848 16.0412 19.4356 16.0412 19.6148 15.8763L19.8656 15.6454C20.0448 15.4804 20.0448 15.2495 19.8656 15.0845L12.3046 8.12371C12.1254 7.95876 11.8746 7.95876 11.6954 8.12371L4.13438 15.0845C3.95521 15.2495 3.95521 15.4804 4.13438 15.6454Z"
      fill="#292B29"
    />
  </svg>
);
